import React from 'react';
import { Box } from '@chakra-ui/react';

const BVSummary = ({ productSlug }) => {
  const transformedName = productSlug
    .toLowerCase()
    .trim()
    .replace(`product-`, ``)
    .replace(/[%]|w\/w/g, ``)
    .replace(/ +/g, `-`);

  return (
    <Box
      mt="1"
      data-bv-show="rating_summary"
      data-bv-product-id={`product-${transformedName}`}
    />
  );
};

export default BVSummary;
